/* eslint-disable import/no-cycle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import { Dropdown } from '@glu/dropdown-react';
import classnames from 'classnames';
import template from 'lodash/template';
import get from 'lodash/get';
import memoize from 'lodash/memoize';

import { withFormContext } from '@glu/validation-react';
import styles from './wirePayment.styles';

// gluValidations
// import Input from '../gluValidation/Input';
import Input from './components/WireInput';
import { maxCharactersTemplate } from '../gluValidation/utils';
import { lt, regexp } from '../../utils/validations/gluValidations';

// utils
import AppPropTypes from '../../proptypes/AppPropTypes';
import { buildAccountList, specialChars } from './utils';
import { MATCHERS } from '../../constants';
import { buildDropdownProps } from '../createPayment/CreatePayment.utils';
import { mapValueBack, getAmountTypeOptions } from '../createPayment/CreatePayment.dropdowns';
import { getPermissions } from './WirePayment.permissions';

// components
import PaymentAdditionalDetails from './partials/PaymentAdditionalDetails';
import PaymentDetails from './partials/PaymentDetails';
import withLocale from '../withLocale/withLocale';
import PaymentInfo from './components/PaymentInfo';

// api
import { getAvailableBusinessDays } from '../../api/payments/service';

const FormContextWrapper = ({ children, data, validate }) =>
  children({ formData: data, gluValidate: validate });
const FormContext = withFormContext(FormContextWrapper);
class WirePaymentComponent extends Component {
  static defaultProps = {
    classes: {},
    locale: {},
    paymentType: '',
    services: null,
    paymentAccounts: [],
    onChange: null,
    fields: {},
    wirePreferences: {},
    form: {},
    type: '',
    onLoad: null,
    fromTemplate: false,
    fxRates: [],
    formChange: null,
    validate() {},
    paymentTypeOptions: [],
    action: '',
    onParentUpdate() {},
    preloaded: false,
    formState: {},
    isTemplate: false
  };

  static propTypes = {
    classes: AppPropTypes.jssClasses,
    locale: AppPropTypes.locale,
    paymentType: PropTypes.string,
    services: PropTypes.shape({}),
    paymentAccounts: PropTypes.arrayOf(PropTypes.shape({})),
    onChange: PropTypes.func,
    fields: PropTypes.shape({}),
    form: PropTypes.shape({}),
    fxRates: PropTypes.arrayOf(PropTypes.shape({})),
    amountTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    wirePreferences: PropTypes.shape({}),
    type: PropTypes.string,
    onLoad: PropTypes.func,
    fromTemplate: PropTypes.bool,
    formChange: PropTypes.func,
    validate: PropTypes.func,
    paymentTypeOptions: PropTypes.arrayOf(PropTypes.shape({})),
    action: PropTypes.string,
    onParentUpdate: PropTypes.func,
    preloaded: PropTypes.bool,
    formState: PropTypes.shape({}),
    isTemplate: PropTypes.bool
  };

  state = {
    bankCodes: {},
    bankCodePage: 1,
    matchBy: '',
    searching: true,
    bankCodeData: {}
  };

  currency = mapValueBack(this.props.fxRates, {
    form: this.props.fields,
    type: 'currency'
  }).currency;

  getAvailableBusinessDays = memoize(() => {
    const {
      fields: { paymentTypeStr }
    } = this.props;
    return getAvailableBusinessDays({
      paymentMethod: paymentTypeStr.toLowerCase(),
      currency: this.currency || null
    });
  });

  getDefaultName = (option, id) => {
    const optionId = Array.isArray(id) ? id[0] : id;
    if (!optionId || !option) {
      return null;
    }
    const getId = optionId.id ? optionId.id : optionId;

    const elem = option.find((x) => x.id.toString() === getId.toString());
    return get(elem, 'name');
  };

  render() {
    const {
      action,
      amountTypes,
      classes: { addressBox, row, title },
      fields,
      formChange,
      formState,
      fromTemplate: ft,
      fxRates,
      isTemplate,
      locale,
      onLoad,
      onParentUpdate,
      paymentAccounts,
      paymentTypeOptions,
      preloaded,
      services,
      type,
      validate,
      wirePreferences
    } = this.props;

    const extras = getPermissions({ wirePreferences, paymentType: fields.paymentTypeStr, locale });
    const templatedRelated = action.includes('template');

    this.accounts = buildAccountList(locale, paymentAccounts);

    return (
      <FormContext>
        {({ gluValidate }) => {
          return (
            <>
              <legend className="visuallyHidden">
                {template(locale['wirePayment.title'])({ type: fields.paymentTypeStr })}
              </legend>
              <div className="col-xs-12 form-group">
                {!templatedRelated && (
                  <PaymentInfo formState={formState} state={fields} data={{ fxRates }} />
                )}
                <div className={row}>
                  <h2 className={classnames(title, 'col-xs-12')}>
                    {locale['wirePayment.originator']}
                  </h2>
                  <Dropdown
                    {...buildDropdownProps(locale, {
                      field: 'originatorAccountId',
                      labelText: locale['common.fromAccount'],
                      onChange: async (name, value) => {
                        formChange(name, value);
                        if (fields.amount) gluValidate('amount');
                      },
                      htmlId: 'originatorAccountId',
                      rootClassName: 'col-xs-3 originator',
                      formGroup: false,
                      options: this.accounts,
                      type,
                      showTooltip: true,
                      format: (data) => this.getDefaultName(this.accounts, data),
                      validators: [{ required: true, msg: locale['validation.required'] }],
                      defaultValue:
                        fields?.originatorAccountId &&
                        this.accounts.filter(
                          (account) => account.id === fields?.originatorAccountId[0]?.id
                        ),
                      disabled: ft
                    })}
                  />
                </div>

                <div className={row}>
                  <h2 className={classnames(title, 'col-xs-12')}>
                    {locale['wirePayment.beneficiary']}
                  </h2>

                  <Input
                    className="col-xs-3"
                    id="accountName"
                    name="accountName"
                    label={locale['common.name']}
                    type="text"
                    debounceInput
                    defaultValue={get(fields.beneficiaryAccountInfo, 'accountName')}
                    maxLength={35}
                    validators={[
                      { required: true, msg: locale['validation.required'] },
                      lt({ maxLength: 35, msg: maxCharactersTemplate(locale, 35) }),
                      specialChars({
                        locale,
                        paymentType: fields.paymentTypeStr,
                        prefs: wirePreferences
                      })
                    ]}
                    disabled={ft}
                  />
                </div>

                <div className={row}>
                  <div className={classnames('col-xs-3', addressBox)}>
                    <Input
                      id="address1"
                      name="address1"
                      label={template(locale['wirePayment.line'])({ line: 1 })}
                      debounceInput
                      defaultValue={fields.address1}
                      maxLength={35}
                      optional={extras.address1 && extras.address1.optional}
                      validators={[
                        regexp({
                          regexp: MATCHERS.ALLOWED_CHAR_REGEX,
                          msg: locale['validation.regexp']
                        }),
                        specialChars({
                          locale,
                          paymentType: fields.paymentTypeStr,
                          prefs: wirePreferences
                        }),
                        (extras.address1 && extras.address1.extra) || {},
                        lt({ maxLength: 35, msg: maxCharactersTemplate(locale, 35) })
                      ]}
                      disabled={ft}
                    />
                    <span className="helpMessage">{locale['wire.physicalAddress']}</span>
                  </div>

                  <Input
                    id="address2"
                    name="address2"
                    label={template(locale['wirePayment.line'])({ line: 2 })}
                    className="col-xs-3"
                    debounceInput
                    defaultValue={fields.address2}
                    maxLength={35}
                    optional={extras.address2 && extras.address2.optional}
                    validators={[
                      regexp({
                        regexp: MATCHERS.ALLOWED_CHAR_REGEX,
                        msg: locale['validation.regexp']
                      }),
                      specialChars({
                        locale,
                        paymentType: fields.paymentTypeStr,
                        prefs: wirePreferences
                      }),
                      (extras.address2 && extras.address2.extra) || {},
                      lt({ maxLength: 35, msg: maxCharactersTemplate(locale, 35) })
                    ]}
                    disabled={ft}
                  />
                </div>

                <div className={row}>
                  <Input
                    id="address3"
                    name="address3"
                    label={template(locale['wirePayment.line'])({ line: 3 })}
                    className="col-xs-3"
                    debounceInput
                    defaultValue={fields.address3}
                    maxLength={35}
                    optional={extras.address3 && extras.address3.optional}
                    validators={[
                      regexp({
                        regexp: MATCHERS.ALLOWED_CHAR_REGEX,
                        msg: locale['validation.regexp']
                      }),
                      specialChars({
                        locale,
                        paymentType: fields.paymentTypeStr,
                        prefs: wirePreferences
                      }),
                      (extras.address3 && extras.address3.extra) || {},
                      lt({ maxLength: 35, msg: maxCharactersTemplate(locale, 35) })
                    ]}
                    disabled={ft}
                  />
                </div>

                <div className={row}>
                  <PaymentDetails
                    type={type}
                    action={action}
                    fromTemplate={ft}
                    formState={fields}
                    source={formState}
                    formChange={formChange}
                    onLoad={onLoad}
                    services={services}
                    validate={validate}
                    onParentUpdate={onParentUpdate}
                    preloaded={preloaded}
                    isTemplate={isTemplate}
                    data={{
                      fxRates,
                      amountTypes: amountTypes || getAmountTypeOptions(),
                      wirePreferences,
                      paymentTypeOptions,
                      paymentAccounts
                    }}
                  />
                </div>

                <div className={row}>
                  <PaymentAdditionalDetails
                    formChange={formChange}
                    preferences={wirePreferences}
                    formState={fields}
                    onLoad={onLoad}
                    type={type}
                    fromTemplate={ft}
                    isTemplate={isTemplate}
                    data={{
                      paymentTypeOptions
                    }}
                  />
                </div>
              </div>
            </>
          );
        }}
      </FormContext>
    );
  }
}

const Styled = withStyles(styles)(WirePaymentComponent);
export default withLocale(Styled);
